import { Channel } from './skill';

export type TQuickAppsMeta = {
    max_size_per_app_b: number;
    available_size_b: number;
    current_size_b: number;
};

export enum QuickAppStatus {
    PROCESSING = 'processing',
    ERROR = 'error',
}

export enum QuickAppError {
    APK_DECLINED = 'apk_declined',
}

export interface IQuickApp {
    id: string;
    name: string;
    channel: Channel;
    status: QuickAppStatus;
    size_b: number;
    logo_url?: string;
    error?: QuickAppError;
}
